import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchProfessionalProfile,
  INVITE_PROFESSIONALS_TO_JOBS,
  inviteProfessionalsToJobs,
} from '~/actions';
import { useGetInvitableOnsiteInterviews } from '~/domain/PermanentJobs';
import { useAppSelector, useLoading } from '~/hooks';
import useIsSuccess from '~/hooks/useIsSuccess';

const INVITE_ACTIONS = [INVITE_PROFESSIONALS_TO_JOBS];

export const useInviteToExistingInterviewModal = (
  isOpen: boolean,
  jobPostingId: string,
  professionalId: string,
  officeId: string,
) => {
  const dispatch = useDispatch();
  const [selectedInterviewIds, setSelectedInterviewIds] = useState<string[]>([]);

  const { data: interviews, isLoading } = useGetInvitableOnsiteInterviews(
    { postingId: jobPostingId, professionalId },
    { enabled: isOpen },
  );

  const professional = useAppSelector((state) => state.user.professionalProfile);
  const { isLoading: isLoadingInvite } = useLoading(INVITE_ACTIONS);
  const { isSuccess: isSuccessInvite, clearSuccess: clearSuccessInvite } =
    useIsSuccess(INVITE_ACTIONS);

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchProfessionalProfile(professionalId, officeId));
    }
  }, [isOpen, professionalId, officeId, dispatch]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedInterviewIds([]);
      clearSuccessInvite();
    }
  }, [isOpen, clearSuccessInvite]);

  const handleToggle = (id: string) => {
    setSelectedInterviewIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const handleInvite = () => {
    dispatch(
      inviteProfessionalsToJobs({
        jobIds: selectedInterviewIds,
        professionalIds: [professionalId],
        isJobsInvite: false,
        officeId,
      }),
    );
  };

  return {
    interviews,
    isLoading,
    isLoadingInvite,
    isSuccessInvite,
    professional,
    selectedInterviewIds,
    handleInvite,
    handleToggle,
  };
};
